module.exports = __webpack_public_path__ + "img/rincian-2.ab0b15da.jpg";